<div *ngIf="open" class="nd">
  <div class="nd__scrim" (click)="phase !== 'setting' && close()"></div>
  <div #panel class="nd__panel" role="dialog" aria-modal="true" aria-labelledby="cc-nd-title" tabindex="-1" cdkTrapFocus>
    <div class="nd__head">
      <span class="nd__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.phone"></path></svg>
      </span>
      <span class="nd__titles">
        <b id="cc-nd-title" class="nd__title">{{ 'shell.number.title' | transloco }}</b>
        <span class="nd__text">{{ 'shell.number.text' | transloco }}</span>
      </span>
      <button type="button" class="nd__x" [attr.aria-label]="'shell.number.close' | transloco" [disabled]="phase === 'setting'" (click)="close()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path [attr.d]="icon.close"></path></svg>
      </button>
    </div>

    <div *ngIf="phase === 'setting'" class="nd__state" role="status">
      <span class="nd__row">
        <span class="nd__spin" aria-hidden="true"></span>
        <span class="nd__col">
          <b>{{ 'shell.number.setting' | transloco: { n: settingId } }}</b>
          <span class="nd__muted">{{ 'shell.number.settingText' | transloco }}</span>
        </span>
      </span>
      <span class="nd__bar" aria-hidden="true"><span class="nd__bar-fill"></span></span>
    </div>

    <div *ngIf="phase === 'reload'" class="nd__state nd__row" role="status">
      <span class="nd__ok" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.check"></path></svg>
      </span>
      <span class="nd__col">
        <b>{{ 'shell.number.reloadTitle' | transloco: { n: settingId } }}</b>
        <span class="nd__muted">{{ 'shell.number.reloadText' | transloco }}</span>
      </span>
    </div>

    <div *ngIf="phase === 'error'" class="nd__error" role="alert">
      <span class="nd__row">
        <span class="nd__bad" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.warn"></path></svg>
        </span>
        <span class="nd__col">
          <b>{{ 'shell.number.error' | transloco }}</b>
          <span>{{ errorText || ('shell.number.errorText' | transloco) }}</span>
        </span>
      </span>
      <button type="button" class="nd__primary" (click)="retry()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="icon.reload"></path></svg>
        {{ 'shell.number.retry' | transloco }}
      </button>
    </div>

    <ng-container *ngIf="phase === 'list' || phase === 'error'">
      <div *ngIf="loading && !cells.length" class="nd__loading" role="status">
        <b>{{ 'shell.number.loadingList' | transloco }}</b>
        <span class="nd__skeleton"><span></span><span></span><span></span><span></span></span>
      </div>

      <ng-container *ngIf="!loading || cells.length">
        <div *ngIf="cells.length" class="nd__legend">
          <span><i class="nd__dot nd__dot--free"></i>{{ 'shell.number.legendFree' | transloco: { n: freeCount } }}</span>
          <span><i class="nd__dot nd__dot--busy"></i>{{ 'shell.number.legendBusy' | transloco: { n: busyCount } }}</span>
          <span><i class="nd__dot nd__dot--mine"></i>{{ 'shell.number.legendMine' | transloco }}</span>
        </div>

        <div *ngIf="cells.length" class="nd__grid">
          <button *ngFor="let c of cells" type="button" class="nd__cell nd__cell--{{ c.kind }}" [disabled]="c.kind !== 'free'"
            [attr.aria-current]="c.kind === 'mine' ? 'true' : null" (click)="pick(c)">
            <span class="nd__bar-left" aria-hidden="true"></span>
            <b class="nd__num">{{ c.id }}</b>
            <span class="nd__col nd__grow">
              <span class="nd__kind">{{ 'shell.number.' + c.kind | transloco }}</span>
              <span class="nd__who">{{ c.kind === 'free' ? ('shell.number.freeHint' | transloco) : (c.who | fio) }}</span>
            </span>
            <span *ngIf="c.kind === 'mine'" class="nd__check" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="icon.check"></path></svg>
            </span>
            <span *ngIf="c.kind === 'busy' && c.initials" class="nd__initials" aria-hidden="true">{{ c.initials }}</span>
          </button>
        </div>

        <p *ngIf="!cells.length" class="nd__empty">{{ 'shell.number.empty' | transloco }}</p>
      </ng-container>
    </ng-container>

    <div class="nd__foot">
      <span>{{ 'shell.number.foot' | transloco }}</span>
      <button type="button" class="nd__btn" [disabled]="phase === 'setting'" (click)="close()">{{ 'shell.number.close' | transloco }}</button>
    </div>
  </div>
</div>
